<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (clientWidth >= 800) {
      clientWidth = 800
    }
    if (!clientWidth) return
    docEl.style.fontSize = 100 * (clientWidth / 375) + 'px'
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)
export default {
  name: 'App',
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'MyFont';
  src: url('@/assets/font/AlimamaShuHeiTi-Bold.ttf') format('truetype');
}
.row{
  display: flex;
  flex-direction: row;
}
.column{
  display: flex;
  flex-direction: column;
}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html,
body {
  width:100%;
  /* height:100%; */
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0;
  font: 400 0.24rem/1.5 "PingFang-SC-Regular", "Helvetica Neue", "Helvetica";
  line-height: 1;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-overflow-scrolling: touch;
}
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
input[type=button],input[type=text],input[type=password]{-webkit-appearance:none;outline:none}
a,
img,
body,
button,
div,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
html,
img,
input,
li,
menu,
ol,
p,
textarea,
ul,
figure,
dl,
dt,
dd {
  padding: 0;
  margin: 0;
  border: 0;
}
li,
ul,
dl,
dt,
dd {
  list-style: none
}
b,
em,
h1,
h2,
h3,
h4,
h5,
h6,
i,
th,
td {
  font-weight: 400;
  font-style: normal
}

body,
button,
input,
select,
textarea,
img {
  outline: 0;
  color: #000;
}

button,
input[type=button],
input[type=password],
input[type=submit],
input[type=text],
textarea {
  -webkit-appearance: none
}

a,
a:visited {
  text-decoration: none;
}

.img img,
video {
  vertical-align: middle
}

img {
  vertical-align: middle;
  border: 0;
  max-width: 100%;
}

body {
  min-width: 320px;
  background: transparent;
}

.clear:after {
  content: '';
  display: block;
  clear: both
}
.clearfix:after{
  display:block;
  clear:both;
  content:"";
  visibility:hidden;
  height:0;
}
.clearfix{
  zoom:1;
}
.el-loading-spinner .path{
  stroke: #299939;
}
#app {
  max-width: 800px;
  /* min-height:100%; */
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
@media all and (min-width:800px) {
  #app {
    border: 1px solid #ccc;
  }
}

</style>